import { render, staticRenderFns } from "./EdInputParametro.vue?vue&type=template&id=cbf4a958&"
import script from "./EdInputParametro.vue?vue&type=script&lang=js&"
export * from "./EdInputParametro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports